import { useRouter } from "next/router";
import Layout from "../../components/layout";
import { useState, useEffect } from "react";
import style from "./faq.module.scss";
import { HandySvg } from "handy-svg";
import getCommonLocales from "../../locales/locales_common";
import getFaqLocales from "../../locales/locales_faq";
import OpenGraphTwitterCard from "../../components/seo/OpenGraphTwitterCard";
import MainBlob from "../../components/animate/MainBlob";
import { getQuestionsList } from "../../constants/faq";

export default function FAQ() {
	const router = useRouter();
	const [filter, setFilter] = useState("general_information");

	let { locale, pathname } = router;

	const dictionary = { ...getCommonLocales(locale), ...getFaqLocales(locale) };

	const [questions, setQuestions] = useState(getQuestionsList(dictionary, filter));

	useEffect(
		() => {
			if (locale) {
				let arr = { ...getCommonLocales(locale), ...getFaqLocales(locale) };
				setQuestions(getQuestionsList(arr, filter));
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[locale]
	);

	const selectFilter = (newFilter) => {
		if (newFilter === filter) return;

		setOpenQuestion([]);
		setFilter(newFilter);
		setQuestions(getQuestionsList(dictionary, newFilter));
	};

	const toggleQuestionGeneral = (categoryIndexIndex, listIndex) => {
		let arr = [...questions];

		arr[categoryIndexIndex].list = arr[categoryIndexIndex].list.map((item, index) => {
			item.active = index === listIndex ? !item.active : item.active;
			return item;
		});

		setQuestions([...arr]);
	};

	const [openQuestions, setOpenQuestion] = useState([]);
	const checkActiveQuestion = (id) => {
		return openQuestions.includes(id);
	};

	const toggleQuestion = (id) => {
		checkActiveQuestion(id)
			? setOpenQuestion((prev) => { return prev.filter((item) => item !== id); })
			: setOpenQuestion((prev) => [...prev, id]);
	};


	const getCanonicalLink = (locale) => {
		const enList = ["en", "ja", "ar"];

		if (enList.includes(locale)) {
			return `https://bgrem.ai/faq/`;
		} else {
			return `https://bgrem.ai/${locale}/faq/`;
		}
	};

	return (
		<Layout mainClassName="faq">
			<OpenGraphTwitterCard title={dictionary["title"]} description={dictionary["description"]} url={pathname} canonical={getCanonicalLink(locale)} />
			<section className={`${style.section} section faq-section`}>
				<div className={style.inner}>
					<h1 className="page_title">{dictionary["page title"]}</h1>
					{questions.map((item, index) => {
						return (
							<div key={index} className={style.questions_category_wrapper}>
								{filter === "general_information" && (
									<>
										{item.anchor && <span id={item.anchor} className="anchor"></span>}
										<h2>{item.category}</h2>
										<div className={style.list}>
											{item.list.map((question, key) => {
												return typeof question.question !== "undefined" && question.question.length > 0 ? (
													<div key={key} className={style.item} onClick={() => toggleQuestionGeneral(index, key)}>
														{question.anchor && <span id={question.anchor} className="anchor"></span>}
														<div className={`${style.question} ${question.active ? style.active : ""}`}>
															<h3>{question.question}</h3>
															<HandySvg className={style.arrow} src="/remove_back/magic_bg/arrow.svg" width="16" height="9" />
														</div>
														<div className={style.answer}>
															<div dangerouslySetInnerHTML={{ __html: `<div>${question.answer}</div>` }} />
														</div>
													</div>
												) : (<></>);
											})}
										</div>
									</>
								)}
								{filter !== "general_information" && (
									<div key={index} className={style.list}>
										<div onClick={() => toggleQuestion(item.id)} key={item.id} className={style.item}>
											<div className={`${style.question} ${checkActiveQuestion(item.id) ? style.active : ""}`}>
												<h3>{dictionary["fag"][item.question] || dictionary["faq"][item.question] || dictionary[item.question] || item.question}</h3>
												<HandySvg className={style.arrow} src={"/remove_back/magic_bg/arrow.svg"} width={18} height={10} />
											</div>
											<div className={style.answer}>
												<div>{item.answer}</div>
											</div>
										</div>
									</div>
								)}
							</div>
						);
					})}
				</div>
			</section>
			<MainBlob isFixed={true} />
		</Layout>
	);
}
